import * as ACTION_TYPES from "../actions/actionTypes";
import dotProp from "dot-prop-immutable";

const INITIAL_STATE = {
  hotels: [],
  isNewHotelModalOpen: false,
  isHotelsTableEditable: false,
  newHotels: [],
  isHotelLoading: false,
  isHotelSaving: false,
  isHotelCreating: false,
  hotelsLookup: {},
  isDeleteHotelModalOpen: false,
  deleteHotelIndex: null
};

export default (state = INITIAL_STATE, action) => {
  const { UPDATE_HOTEL_PROPS, MERGE_HOTEL_PROPS, DELETE_HOTEL_PROPS, CLEAR_STATE } = ACTION_TYPES;
  switch (action.type) {
    case UPDATE_HOTEL_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.set(newState, action.payload[i].prop, action.payload[i].value);
      }
      return newState;
    }
    case MERGE_HOTEL_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.merge(newState, action.payload[i].prop, action.payload[i].value);
      }
      return newState;
    }
    case DELETE_HOTEL_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.delete(newState, action.payload[i].prop);
      }
      return newState;
    }
    case CLEAR_STATE: {
      let newState = state;
      newState = INITIAL_STATE;
      return newState;
    }
    default:
      return state;
  }
};
